import React, {Component} from 'react';
import {Grid, Row, Col} from "react-bootstrap";
import TopBreadcumb from "../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SubHeader from "../../../shared/sidebar/SubHeader";
import SidebarComponent from "../../../shared/sidebar/SidebarComponent";
import Links from "../../../utilities/linksConfig/Links";
import PrzegladarkaTable from "./components/PrzegladarkaTable";
import PrzegladarkaService from "./PrzegladarkaService";

export default class PrzegladarkaContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pliki: [],
            typyPlikow: [],
        };
    }

    componentDidMount() {
        this.pobierzPliki()
        this.pobierzListeTypow()
    }

    pobierzPliki() {
        PrzegladarkaService.pobierzListePlikow().then(function (response) {
            this.setState({pliki: response.data})
        }.bind(this))
    }

    pobierzListeTypow() {
        PrzegladarkaService.pobierzListeTypowPlikow().then(function (response) {
            let obj = {}
            for (let i = 0; i < response.data.length; i++) {
                obj = Object.assign(obj, {[response.data[i]]: response.data[i]})
            }
            this.setState({typyPlikow: obj})

        }.bind(this))
    }


    render() {

        return (
            <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path}
                              history={this.props.history}
                              collapsedLinks={this.props.collapsedLinks}
                              handleClickToogleSidebar={(module) => this.props.handleClickToogleSidebar(module)}>
                <Grid fluid={true} id={'PrzegladarkaContainer'}>
                    <Row>
                        <Col sm={12}>
                            <div id="subheader">
                                <TopBreadcumb links={[{addressUrl: '/administracja', text: 'Administracja'}, {
                                    addressUrl: '/administracja/przegladarka',
                                    text: 'Przeglądarka plików'
                                }]}/>
                                <SubHeader currentLink={this.props.match.path}
                                           obecnyKalendarz={this.props.obecnyKalendarz}
                                           history={this.props.history}/>
                            </div>
                        </Col>
                        <Col xs={12}>
                            <PrzegladarkaTable data={this.state.pliki} typyPlikow={this.state.typyPlikow}/>
                        </Col>
                    </Row>
                </Grid>
            </SidebarComponent>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/administracja/przegladarka_plikow/PrzegladarkaContainer.js